module.exports = __webpack_public_path__ + "assets/img/18_1842.9232c220.jpg";